// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".transcript-modal--TckAM{white-space:pre-wrap}.transcript-modal--TckAM .modal-header .material-symbols-outlined{vertical-align:middle;color:#b4bccd}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transcript-modal": "transcript-modal--TckAM"
};
export default ___CSS_LOADER_EXPORT___;
